import type {
  OrderFailedCollectionDecisionRequestType,
  OrderFailedCollectionDecisionResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useOrderFailedCollectionDecision = (orderId: number) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: OrderFailedCollectionDecisionRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `orders/${orderId}/failed-collection-decision`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse<OrderFailedCollectionDecisionResponseType>(
            response,
          ).data,
      ),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [user?.uid, business?.id, ServerStateKeys.Orders],
        }),
        queryClient.invalidateQueries({
          queryKey: [
            user?.uid,
            business?.id,
            ServerStateKeys.OrderDeliveryHistory,
            orderId,
          ],
        }),
      ]);
    },
  });
};
